/* PDP hero image carousel — thumbnail rail drives a crossfade on the main slide, matching
   the source (it stacks slides and transitions opacity rather than scrolling them). Prev/next
   arrow buttons step through the same slides (only visible in the Minimax mobile layout,
   see section-product-minimax-hero.css). */
(() => {
  document.querySelectorAll('.product-hero-carousel').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-hero-carousel-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-hero-carousel-thumb]'));
    const status = root.querySelector('[data-hero-carousel-status]');
    const prevButton = root.querySelector('[data-hero-carousel-prev]');
    const nextButton = root.querySelector('[data-hero-carousel-next]');
    if (slides.length < 2) return;

    let activeIndex = 0;

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      thumbs.forEach((thumb, i) => {
        const isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) thumb.scrollIntoView({ block: 'nearest' });
      });
      if (status) status.textContent = `Slide ${index + 1} of ${slides.length}`;
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setActive(index));
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        setActive((activeIndex - 1 + slides.length) % slides.length);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        setActive((activeIndex + 1) % slides.length);
      });
    }
  });
})();
